<template>
  <div>
    <a-skeleton :active="active" :loading="active" width="10px" :paragraph="{ rows: 2 }" />
    <div class="ts-grid ts-grid-cols-1 lg:ts-grid-cols-4 ts-gap-4" v-if="!active">
      <div class="ts-w-full ts-px-5 ts-py-8 ts-border ts-bg-white ts-rounded-lg">
        <p class="ts-font-heading-font ts-mb-1 ts-capitalize">{{ $t('dashboard.superDealer') }}</p>
        <h3 class="ts-font-bold ts-font-robot ts-mb-0 ts-text-2xl ts-text-pink-600">{{ dealer.super_dealer }}</h3>
      </div>
      <div class="ts-w-full ts-px-5 ts-py-8 ts-border ts-bg-white ts-rounded-lg">
        <p class="ts-font-heading-font ts-mb-1 ts-capitalize">{{ $t('dashboard.subDealer') }}</p>
        <h3 class="ts-font-bold ts-font-robot ts-mb-0 ts-text-2xl ts-text-blue-600">{{ dealer.sub_dealer }}</h3>
      </div>
      <div class="ts-w-full ts-px-5 ts-py-8 ts-border ts-bg-white ts-rounded-lg">
        <p class="ts-font-heading-font ts-mb-1 ts-capitalize">{{ $t('dashboard.customer') }}</p>
        <h3 class="ts-font-bold ts-font-robot ts-mb-0 ts-text-2xl ts-text-red-600">{{ dealer.customer }}</h3>
      </div>
      <div class="ts-w-full ts-px-5 ts-py-8 ts-border ts-bg-white ts-rounded-lg">
        <p class="ts-font-heading-font ts-mb-1 ts-capitalize">{{ $t('dashboard.user') }}</p>
        <h3 class="ts-font-bold ts-font-robot ts-mb-0 ts-text-2xl">{{ dealer.user }}</h3>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'totalDealer',
  data() {
    return {
      active: false,
      dealer: []
    }
  },
  created(){
    this.onFetchData()
  },
  methods: {
    ...mapActions('dashboard/record', ['totalDealer']),
    onFetchData(){
      this.active = true
      this.totalDealer()
        .then(response => {
          this.dealer = response.data
        })
        .finally(() => {
          this.active = false
        })
    }
  }
}
</script>